import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewInternshipPageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ViewInternshipPage" */
      './ViewInternshipPage.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
